(function () {
  'use strict';

  function initRecipeLineup(el) {
    if (!el) return;

    var sectionId = el.dataset.sectionId;
    var stage   = el.querySelector('.rl-stage');
    var track   = el.querySelector('.rl-track');
    var cards   = Array.prototype.slice.call(el.querySelectorAll('.rl-card-wrap'));
    var prevBtn = el.querySelector('.rl-prev');
    var nextBtn = el.querySelector('.rl-next');
    var mobPrev = el.querySelector('.rl-mob-prev');
    var mobNext = el.querySelector('.rl-mob-next');
    var total   = cards.length;
    var curr    = 0;
    var busy    = false;

    /* ─── Cache des dimensions ─── */
    var cachedWidths  = [];
    var cachedOffsets = [];
    var cachedGap     = 16;

    function buildCache() {
      cachedGap    = parseInt(getComputedStyle(el).getPropertyValue('--gap'), 10) || 16;
      cachedWidths = cards.map(function (c) { return c.offsetWidth; });
      cachedOffsets = [0];
      for (var i = 1; i < total; i++) {
        cachedOffsets[i] = cachedOffsets[i - 1] + cachedWidths[i - 1] + cachedGap;
      }
    }

    function getVisibleCount() {
      if (!cachedWidths[0]) return 1;
      var stageW = stage.offsetWidth;
      return Math.max(1, Math.round((stageW + cachedGap) / (cachedWidths[0] + cachedGap)));
    }

    function applyOffset(idx) {
      var offset = cachedOffsets[idx] || 0;
      track.style.transform = 'translateX(-' + offset + 'px)';
    }

    /* ─── Navigation ─── */
    function goTo(idx) {
      if (busy) return;
      var visible = getVisibleCount();
      var maxIdx  = Math.max(0, total - visible);
      var next    = idx > maxIdx ? 0 : idx < 0 ? maxIdx : idx;
      if (next === curr) return;

      busy = true;
      curr = next;

      track.style.willChange = 'transform';
      applyOffset(curr);

      setTimeout(function () {
        track.style.willChange = 'auto';
        busy = false;
      }, 500);
    }

    function move(dir) { goTo(curr + dir); }

    if (prevBtn) prevBtn.addEventListener('click', function () { move(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { move(1); });
    if (mobPrev) mobPrev.addEventListener('click', function () { move(-1); });
    if (mobNext) mobNext.addEventListener('click', function () { move(1); });

    /* ─── Flip au clic / clavier ─── */
    cards.forEach(function (card) {
      function handleFlip(e) {
        e.preventDefault();
        var isFlipped = card.classList.contains('is-flipped');
        cards.forEach(function (c) { c.classList.remove('is-flipped'); });
        if (!isFlipped) card.classList.add('is-flipped');
      }
      card.addEventListener('click', handleFlip);
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleFlip(e); }
        if (e.key === 'ArrowRight') move(1);
        if (e.key === 'ArrowLeft')  move(-1);
      });
    });

    /* ─── Swipe tactile ─── */
    var swipeX         = 0;
    var swipeY         = 0;
    var axisLocked     = false;
    var swipeOnFlipped = false;

    track.addEventListener('touchstart', function (e) {
      swipeX         = e.changedTouches[0].screenX;
      swipeY         = e.changedTouches[0].screenY;
      axisLocked     = false;
      swipeOnFlipped = !!e.target.closest('.rl-card-wrap.is-flipped');
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (axisLocked) return;
      var dx = Math.abs(e.changedTouches[0].screenX - swipeX);
      var dy = Math.abs(e.changedTouches[0].screenY - swipeY);
      if (dy > dx) axisLocked = true;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (axisLocked || swipeOnFlipped) return;
      var diff = e.changedTouches[0].screenX - swipeX;
      if (Math.abs(diff) > 50) move(diff < 0 ? 1 : -1);
    }, { passive: true });

    /* ─── Resize avec debounce + AbortController ─── */
    var resizeController = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var resizeTimer;

    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        buildCache();
        var visible = getVisibleCount();
        var maxIdx  = Math.max(0, total - visible);
        if (curr > maxIdx) curr = maxIdx;
        applyOffset(curr);
      }, 150);
    }

    var resizeOptions = resizeController ? { signal: resizeController.signal } : {};
    window.addEventListener('resize', onResize, resizeOptions);

    /* ─── Nettoyage dans l'éditeur Shopify ─── */
    var animObserver = null;

    document.addEventListener('shopify:section:unload', function (e) {
      if (e.detail && e.detail.sectionId === sectionId) {
        if (resizeController) resizeController.abort();
        clearTimeout(resizeTimer);
        if (animObserver) animObserver.disconnect();
      }
    });

    /* ─── IntersectionObserver pour les animations ─── */
    if ('IntersectionObserver' in window) {
      animObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            el.classList.add('rl-in-view');
          } else {
            el.classList.remove('rl-in-view');
          }
        });
      }, { threshold: 0.1 });
      animObserver.observe(el);
    } else {
      el.classList.add('rl-in-view');
    }

    /* ─── Init ─── */
    buildCache();
    applyOffset(0);
  }

  /* ─── Auto-initialisation ─── */
  function initAll() {
    document.querySelectorAll('.rl-wrap[data-section-id]').forEach(initRecipeLineup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ─── Shopify theme editor: section ajoutée dynamiquement ─── */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.rl-wrap[data-section-id]');
    if (el) initRecipeLineup(el);
  });

}());
